var ExternalPopup = function () {
    var $document = $(document);

    var $element = $('.external-popup.js-extpop-element');
    var $overlay = $('.external-popup-overlay.js-extpop-overlay');
    
    var $orderElement = $('.order-popup.js-extpop-element');
    var $orderOverlay = $('.order-popup-overlay.js-extpop-overlay');


    var $link = $('.js-extpop-link');
    var $video = $('.video-fullwidth__play-button');
    var $number = $('.js-extpop-number');
    var count = 5;
    var timer = {};

    var $orderNumber = $('.js-ordpop-number');
    var orderCount = 8;
    var orderTimer = {};


    function init() {
        removeEvents();
        attachLinkEvents();
        attachDocumentEvents();
    }

    function removeEvents() {
        $('a').not($link).off('click.external');
        $link.off('click.external');
        $document.off('keydown.external');
    }

    /**
    * Attach click event to all links
    */
    function attachLinkEvents() {
        var hostRegex = new RegExp(location.hostname);
        var ignoredURLS = ['hooters.olo.com', 'olo.com', 'order.hootswings.com','order.hooters.com', 'jobs.hooters.com', 'shop.hooters.com', 'hootswings.com', 'www.originalhooters.com',  'www.ezcater.com', 'ezcater.com', 'www.buyatab.com', 'buyatab.com', 'wbiprod.storedvalue.com'];
        var orderURLS = []

        $('a').not($link).not($video).each(function () {
            $(this).on('click.external', function(e) {

                var ignoredURL = false;
                var orderURL = false;

                var href = new URL( $(this).attr('href') );

                if($(this).attr('href').includes('tel')){
                    return true;
                }

                orderURLS.forEach( (url) => {
                    if(url.includes(href.host)) {
                        orderURL = true;
                        ignoredURL = true;
                    }
                });

                ignoredURLS.forEach( (url) => {
                    if(url.includes(href.host)) {
                        ignoredURL = true;
                        orderURL = false;
                    }
                });

                console.log('this', $(this).attr('href').includes('tel'))

                if ( (orderURL == true) && $(this).hasClass('header-button--order-online') ) {
                    e.preventDefault();

                    $link.attr('href', $(this).attr('href'));
                    showOrderPopup();
                    startOrderCountdown();
                }

                if ( (orderURL == true) && $(this).hasClass('hoops-order-button') ) {
                    e.preventDefault();

                    $link.attr('href', $(this).attr('href'));
                    showOrderPopup();
                    startOrderCountdown();
                }

                if ( (!hostRegex.test(this.hostname)) && (ignoredURL == false) &&  (orderURL == false)  ) {
                    e.preventDefault();

                    $link.attr('href', $(this).attr('href'));
                    showPopup();
                    startCountdown();
                }

               
            })
        });
        $link.on('click.external', function(e) {
            e.preventDefault();
            if(typeof dataLayer !== 'undefined'){
                dataLayer.push({
                    'event': 'external_link_impatient',
                    'link': $link.attr('href'),
                });
            }
            proceed();
        });
    }

    function attachDocumentEvents() {

        //Keep Focus in Modal
        $document.on('keydown.external', function(e) {
            if (e.which === 9 && $overlay.is(':visible')) {
                e.preventDefault();
            }
        });
    }

    /**
    * Show the popup modal
    */
    function showPopup() {
        $overlay.addClass('is-visible');
        $element.addClass('is-visible').attr('aria-hidden', 'false');
        $link.focus();
        if(typeof dataLayer !== 'undefined'){
            dataLayer.push({
                'event': 'external_link',
                'link': $link.attr('href'),
            });
        }
    }

    /**
    * Hide the popup modal
    */
    function hidePopup() {
        $number.html(count);
        $element.removeClass('is-visible').attr('aria-hidden', 'true');
        $overlay.removeClass('is-visible');
    }

    /**
    * Show the order popup modal
    */
    function showOrderPopup() {
        $orderOverlay.addClass('is-visible');
        $orderElement.addClass('is-visible').attr('aria-hidden', 'false');
        $link.focus();
        if(typeof dataLayer !== 'undefined'){
            dataLayer.push({
                'event': 'order_link',
                'link': $link.attr('href'),
            });
        }
    }

    /**
    * Hide the order popup modal
    */
    function hideOrderPopup() {
        $orderNumber.html(orderCount);
        $orderElement.removeClass('is-visible').attr('aria-hidden', 'true');
        $orderOverlay.removeClass('is-visible');
    }

    /**
    * Start the countdown and then proceed on completion
    */
    function startCountdown() {
        var number = count - 1;
        timer = setInterval(function() {
            $number.html(number);
            if (number <= 0) {
                proceed();
            }
            number -= 1;
        }, 1000);
    }

    /**
    * Start the order countdown and then proceed on completion
    */
    function startOrderCountdown() {
        console.log('countdown')
        var number = orderCount - 1;
        orderTimer = setInterval(function() {
            $orderNumber.html(number);
            if (number <= 0) {
                proceed();
            }
            number -= 1;
        }, 1000);
    }

    /**
    * Stop the countdown
    */
    function stopCountdown() {
        clearInterval(timer);
        clearInterval(orderTimer);
    }

    /**
    * Redirect to the URL of the modal link, stop the countdown and hide the modal
    */
    function proceed() {
        stopCountdown();
        hidePopup();
        hideOrderPopup();
        window.location = $link.attr('href');
        $link.attr('href', '#');
    }

    function triggerPopup(target, url) {
        if (typeof url === 'undefined' || typeof target === 'undefined') {
            return false;
        };
        var $link = $(target);
        $link.attr('href', url);
        showPopup();
        showOrderPopup();
        startCountdown();
        startOrderCountdown();
    }

    return {
        init: init,
        triggerPopup: triggerPopup
    }
}